import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

@Component({
    selector: 'app-meta-single-image-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/meta-single-image-template/"
      channelLabel="Meta Single Image Ad"
      namePlaceholder="Enter Meta Single Image Ad template name"
      emptyMessage="No Meta Single Image Ad found!"
      heartbeatType="meta-single-image-template"
      [showSidePreview]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [requiredFields]="requiredFields"
      />
  `
})
export class MetaSingleImageTemplateComponent {
  protected readonly templateType = TypeEnum.META_SINGLE_IMAGE;

  // Image upload and the dropdowns render no text editor, so the empty-field
  // check on save cannot see them — they are required explicitly.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'meta-single-image-cta-text', field: 'Text', label: 'CTA' },
    { blockName: 'meta-single-image-account-type', field: 'AccountType', label: 'Account type' },
    { blockName: 'meta-single-image-image', field: 'Image', label: 'Image' },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'meta-single-image-headline', count: 1, variables: { MetaSingleImageHeadline_1: '' } },
    { name: 'meta-single-image-primary-text', count: 1, variables: { MetaSingleImagePrimaryText_1: '' } },
    { name: 'meta-single-image-cta-text', count: 1, variables: { Text: '' } },
    { name: 'meta-single-image-url', count: 1, variables: { Link: '' } },
    { name: 'meta-single-image-account-type', count: 1, variables: { AccountType: '' } },
    { name: 'meta-single-image-image', count: 1, variables: { Image: '' } },
  ];
}
